/**
 * The worked example that ships with the app.
 *
 * One entry, deliberately: this is the thing a first visitor opens to see what
 * the tool is for, not a gallery. It is served as an ordinary static file
 * rather than bundled, because it is two and a half megabytes of project and
 * nobody who never asks for it should download a byte of it.
 *
 * The build emits it from the repository's own `examples/` directory, so the
 * file the app serves is the same one the tests read and the generator writes
 * — there is no second copy to fall behind.
 */
export interface ExampleProject {
  readonly name: string;
  /** One line, for the card that offers it. */
  readonly summary: string;
  /** Where the file lives in the repository, relative to its root. */
  readonly source: string;
  /** Where the running app fetches it from. */
  readonly path: string;
}

export const EXAMPLE_HOUSE: ExampleProject = {
  name: 'Thornbury Hall',
  summary: 'A two-storey L-plan house in six bonds, with bonded corners and a hipped roof.',
  source: 'examples/ThornburyHall.bwall',
  path: '/examples/ThornburyHall.bwall',
};
